import { Button } from "@/components/ui/baseUi/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/baseUi/dialog"
import { LanguageDropdown } from "@/modules/language/components/languageDropdown"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import { Language } from "@modules/language/utils/languageUtils"
import { type Dispatch, type SetStateAction, useState } from "react"
import { Text } from "@/components/ui/baseUi/text"

type Props = {
  onOpenChange: Dispatch<SetStateAction<boolean>>
  visible: boolean
}

export function LanguagePopup({ onOpenChange, visible }: Props) {
  const [language, setLanguage] = useState<Language | undefined>()
  const { languageService } = useServicesContext()

  return (
    <>
      <Dialog open={visible} onOpenChange={onOpenChange}>
        <DialogContent className="flex w-130 flex-col gap-4">
          <DialogHeader className="flex flex-col gap-4">
            <DialogTitle>
              <Text fontStyle="TL" className="flex w-10 py-4">
                {word("languages.title")}
              </Text>
            </DialogTitle>

            <DialogDescription className="flex flex-col items-start gap-1 text-left">
              <Text fontStyle="BM">{word("languages.subTitle")}</Text>
            </DialogDescription>
          </DialogHeader>

          <LanguageDropdown onChange={setLanguage} selectedLanguage={language} longValues />

          <DialogFooter>
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              {word("global.cancel")}
            </Button>

            <Button
              variant="primary"
              onClick={() => {
                if (language) {
                  languageService.setUserLanguage(language)
                }
                onOpenChange(false)
              }}
            >
              {word("global.save")}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
